<template>
  <Page>
    <section class="stat-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb title="使用数据" style="justify-content: space-between;">
        <ListFilter
         :showButton="false" 
         :formList="filterFormList" 
         @change="dataChangeHandle"
         wstyle="padding: 0; background: transparent; display: block; margin-bottom: 0;"
         itemStyle="width: 100%"
        />
      </Breadcrumb>
      <div class="statlist">
        <div class="item" v-for="(item, index) in stats" :key="index">
          <em :class="item.icon" />
          <div class="detail"><label>{{ item?.label }}</label><span>{{item?.value}}</span></div>
        </div>
      </div>
      <div class="stat-block-wrap">
        <div class="stat-block-title" style="margin-bottom: 0;">
          累计运行次数/次
          <ListFilter :showButton="false" @change="appRunningCountChangeHandle" :formList="runningCountFormList" wstyle="background-color: transparent;padding: 0; margin-bottom: 0;" itemStyle="width: 258px" />
        </div>
        <div class="runtotal-trend-main">
          <Empty v-if="!appRunningChartOptions" />
          <template v-else>
            <ChartItem :options="appRunningChartOptions" />
          </template>
        </div>
      </div>

      <div class="stat-block-wrap" style="flex: 1; overflow: auto; min-height: 560px;">
        <div class="stat-block-title">
          使用者统计
          <ListFilter :showButton="false" @change="appUserChangeHandle" :formList="appUseFormList" wstyle="background-color: transparent;padding: 0; margin-bottom: 0;" itemStyle="width: 258px" />
        </div>
        <el-table :data="appUserStats" style="width: 100%; height: 100%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
          <template #empty><Empty style="margin-top: 56px;" /></template>
          <el-table-column prop="userName" label="用户名" />
          <el-table-column prop="runningCount" label="累计运行次数（次）" />
          <el-table-column prop="subTaskCount" label="累计子任务总数（个）" />
          <el-table-column prop="runningTime" label="累计运行时长（小时）" />
        </el-table>
        <Spagination 
          v-if="appUserTotal>0"
          :page="appUserPage"
          :size="appUserSize"
          :total="appUserTotal"
          @current-change="val => appUserPage = val"
        />
      </div>
    </section>

    <el-dialog v-model="detailFlag" title="详情" width="83%">
      <el-table :data="detailObj?.list" style="width: 100%; height: 80%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
        <template #empty><Empty style="margin-top: 56px;" /></template>
        <el-table-column prop="pid" label="任务ID" />
        <el-table-column prop="id" label="子任务ID" />
        <el-table-column prop="machineName" label="机器名称" />
        <el-table-column prop="status" label="子任务状态" />
        <el-table-column prop="rt" label="用时" />
        <el-table-column prop="createdTime" label="开始时间" />
        <el-table-column prop="updatedTime" label="更新时间" />
      </el-table>
    </el-dialog>
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import moment from 'moment';
  import Page from '@/components/page';
  import ChartItem from '@/components/chartItem';
  import Empty from '@/components/empty';
  import Breadcrumb from '@/components/breadcrumb';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import Announce from '@/components/announce';

  import * as Request from '@/assets/request';

  const updatedDateRange = ref([ moment().startOf('day').format('X')*1000, moment().endOf('day').format('X')*1000 ]);

  /**
   * 全局时间筛选
   */
  const filterFormList = ref([
    {
      type: 'datetimerange', field: 'updatedDateRange', valueFormat: 'x',
      label: '时间区间', placeholder: '请选择', value: [ moment().startOf('day').format('X')*1000, moment().endOf('day').format('X')*1000 ]
    },
  ]);
  const dataChangeHandle = async (data) => {
    console.log('changeHandle------', data)
    updatedDateRange.value = data.updatedDateRange && JSON.parse(JSON.stringify(data.updatedDateRange)) || []
  }

  // 获取所有app
  const allApp = ref([])
  const getAllApp = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getAllApp'
    });
    if(result?.code != 200) return;

    let _options = [];
    if(result?.data?.length > 0) {
      result.data.map(item => {
        if(item.apps?.length > 0) {
          item.apps.map(_item => {
            _options.push({ value: _item?.id, label: _item?.name })
          })
        }
      })
    }
    allApp.value = _options
  }
  onMounted(() => {
    getAllApp()
  });

  /**
   * 统计数据
   */
  const stats = ref([
    { icon: 'stat1', label: '累计运行次数（次）', value: '-' },
    { icon: 'stat2', label: '累计子任务总数（个）', value: '-' },
    { icon: 'stat3', label: '累计运行时长（小时）', value: '-' },
    { icon: 'stat4', label: '约节省人力（人/天 )', value: '-' },
  ])
  const getTotal = async () => {
    const result = await Request.post({
      url: '/22001/facade/stat/getTotal',
      data: {
        dateRange: updatedDateRange.value
      }
    })
    if(result?.code != 200) return;

    stats.value = [
      { icon: 'stat1', label: '累计运行次数（次）', value: result?.data?.runningTotalCount || '-' },
      { icon: 'stat2', label: '累计子任务总数（个）', value: result?.data?.totalSubTaskCount || '-'  },
      { icon: 'stat3', label: '累计运行时长（小时）', value: result?.data?.runningTotalTime || '-'  },
      { icon: 'stat4', label: '约节省人力（人/天 )', value: result?.data?.saveManpowerDay || '-'  },
    ]
  }
  watch(() => updatedDateRange.value, () => {
    getTotal()
  })

  /**
   * 累计运行次数/次
   */
  // 应用过滤
  const runningCountFormList = ref([
    {
      type: 'select', field: 'appId',
      label: '应用名称', placeholder: '请选择',
      options: allApp
    }
  ]);
  // 图表配置
  const appRunningChartOptions = ref(null)
  const appIdForAppRunningCount = ref(null)
  const getAppRunningCount = async () => {
    const data = { dateRange: updatedDateRange.value }
    if(appIdForAppRunningCount.value) {
      data.appId = appIdForAppRunningCount.value
    }
    const result = await Request.post({
      url: '/22001/facade/stat/getAppRunningCount',
      data
    })
    if(result?.code != 200) return;

    let list = result?.data
    if(!list || list.length == 0) return;
    // list = [
    //   { date: '2025-01-14', count: 1000 },
    //   { date: '2025-01-13', count: 800 },
    //   { date: '2025-01-12', count: 600 },
    //   { date: '2025-01-11', count: 100 },
    //   { date: '2025-01-10', count: 400 },
    //   { date: '2025-01-09', count: 200 },
    // ]
    const seriesData = []
    const xAxisData = []
    list.map(lst => {
      if(lst.date) {
        xAxisData.push(moment(lst.date).format('MM/DD'));
        seriesData.push(lst.count)
      }
    })
    appRunningChartOptions.value = {
      legend: false,
      tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          type: 'cross',        // 默认为直线，可选为：'line' | 'shadow' 'cross'
          lable:{

          }
        },
        formatter:function (params) {
          const item = params[0]
          if(!item) return '';
          return `${item?.name}<br />${item?.value}次`
        }
      },
      grid: {
        left: 60,
        top: 40,
        bottom: 20,
        right: 60
      },
      xAxis: [
        {
          type: 'category',
          name: '月/日',
          data: xAxisData,
          axisPointer: {
            type: 'shadow'
          },
          axisLine: {
            lineStyle: {
              color: '#D9D9D9'
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '/次',
          min: 0,
          // max: 10000,
          interval: 200,
          axisLabel: {
            formatter: '{value}'
          },
          splitLine: {
            show: false
          }
        }
      ],
      series: [
        {
          name: 'Count',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' 次';
            }
          },
          data: seriesData,
          itemStyle: {
            normal: {
              color: '#B8DCFF'
            }
          }
        },
        {
          name: 'Count',
          type: 'line',
          data: seriesData,
          lineStyle: {
            normal: {
              color: '#79A5F6'
            }
          },
          itemStyle: {
            normal: {
              color: '#79A5F6'
            }
          }
        }
      ]
    }
  }
  watch(() => [ updatedDateRange.value, appIdForAppRunningCount.value ], () => {
    getAppRunningCount()
  })
  onMounted(() => {
    getAppRunningCount()
  })
  const appRunningCountChangeHandle = data => {
    appIdForAppRunningCount.value = data.appId;
    runningCountFormList.value.map(item => {
      if(item.field == 'appId') {
        item.value = data.appId;
      }
      return item;
    })
  }

  /**
   * 使用者统计
   */
  // 应用过滤
  const appUseFormList = ref([
    {
      type: 'select', field: 'appId',
      label: '应用名称', placeholder: '请选择',
      options: allApp
    }
  ])
  const appUserStats = ref([])
  const appUserTotal = ref(0)
  const appUserSize = ref(50)
  const appUserPage = ref(1)
  const appIdForAppUser = ref(null)
  const getAppUser = async () => {
    const data = { 
      dateRange: updatedDateRange.value,
      page: appUserPage.value,
      size: appUserSize.value
    }
    if(appIdForAppUser.value) {
      data.appId = appIdForAppUser.value
    }
    const result = await Request.post({
      url: '/22001/facade/stat/getAppUser',
      data
    })
    if(result?.code != 200) return;

    appUserStats.value = result?.data?.content || []
    appUserTotal.value = result?.data?.total;
  }
  watch(() => [updatedDateRange.value, appIdForAppUser.value, appUserPage.value], () => {
    getAppUser()
  })
  onMounted(() => {
    getAppUser()
  })
  const appUserChangeHandle = data => {
    appIdForAppUser.value = data.appId;
    appUseFormList.value.map(item => {
      if(item.field == 'appId') {
        item.value = data.appId;
      }
      return item;
    })
  }

  // /**
  //  * 列表
  //  */
  // const list = ref([])
  // const listQuery = ref({})
  // const total = ref(0)
  // const size = ref(50)
  // const page = ref(1)
  // const getList = async () => {
  //   const result = await Request.post({
  //     url: '/22001/facade/stat/getAppUser'
  //   })
  //   if(result?.code != 200) return;

  //   list.value = result?.data?.content;
  //   total.value = result?.data?.total;
  //   console.log('total.value--', total.value)

  //   // list.value = [
  //   //   {"id": 111111,"username": "username","appName": "appNameappNameappNameappNameappName","status": "status"},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   //   {"id": 222222,"username": "username","appName": "appName","status": "status",},
  //   // ]
  // }
  // onMounted(() => {
  //   getList()
  // })
  // onMounted(() => {
  //   getList()
  // })
  // watch(() => [ listQuery.value, page.value ], () => {
  //   getList();
  // }, { deep: true })
</script>

<style scoped lang="less">
@import "./index.less";
</style>
